var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.478516,
    width: 27.1194,
    height: 26,
    rx: 13,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9439 21.6663V13.7597H17.7121L18.1265 10.6784H14.9439V8.71104C14.9439 7.81894 15.2023 7.21093 16.5368 7.21093L18.2387 7.21018V4.45429C17.9442 4.41688 16.934 4.33301 15.7587 4.33301C13.3049 4.33301 11.625 5.76891 11.625 8.40603V10.6785H8.84961V13.7598H11.6249V21.6663L14.9439 21.6663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookWhiteIcon);
export default __webpack_public_path__ + "static/media/facebook_white-icon.5adfe329d5f1a39774e5163671377b6b.svg";
export { ForwardRef as ReactComponent };